import { clx } from '@/utils/clx'

export const LoadingSpinner = ({ className, centered }: { className?: string; centered?: boolean }) => {
	const spinner = (
		<div
			className={clx(`h-8 w-8 animate-spin rounded-full border-b-2 border-black/30 border-b-black`, className)}
		/>
	)

	if (centered) {
		return <div className='flex min-h-[50vh] flex-1 items-center justify-center'>{spinner}</div>
	}

	return spinner
}
